import { common } from '@mui/material/colors'
import { alpha } from '@mui/material/styles'
import { error, info, neutralLight, success, warning } from '../colors'
import { getPrimary } from '../utils'

export const createPalette = (config) => {
    const { colorPreset, contrast } = config
    const primary = getPrimary(colorPreset)

    return {
        action: {
            active: neutralLight[600],
            disabled: alpha(neutralLight[900], 0.38),
            disabledBackground: alpha(neutralLight[900], 0.12),
            focus: alpha(primary.main, 0.16),
            hover: alpha(primary.main, 0.035),
            selected: alpha(primary.main, 0.08)
        },
        background: {
            default: contrast === 'high' ? '#EEF3FA' : '#F3F7FD',
            paper: common.white
        },
        divider: neutralLight[200],
        error,
        info,
        // MUI only understands 'light' and 'dark', and components such as Alert pick their
        // colours with `mode === 'light' ? darken : lighten`. 'white' read as dark there, so
        // every outlined alert's text came out pale on a pale background. Code that needs the
        // app's theme name reads settings.style.theme, not this.
        mode: 'light',
        neutral: neutralLight,
        primary,
        success,
        text: {
            primary: neutralLight[900],
            secondary: neutralLight[600],
            disabled: alpha(neutralLight[900], 0.38)
        },
        warning
    }
}
